import { IProduct } from '@interfaces';

import IconCheckmark from '@img/icons/checkmark-blue.svg';
import IconClose from '@img/modal/close-button.svg';

import styles from '@components/common/products/product.styles';
import { nominations } from '../utils';

export default function BundleUsVsThem({ bundle }: { bundle?: IProduct }) {

    return (
        <div className={styles.bundleUsVsThem}>
            <h3>Bundle Us VS Them</h3>
            <h2>the cerebelly standard</h2>
            <div className='grid-container'>
                <div className='grid-item' />
                <div className='grid-item title'>
                    us
                </div>
                <div className='grid-item title'>
                    them*
                </div>

                <div className='grid-item category'>
                    critical nutrients supporting
                    brain development
                </div>
                <div className='grid-item number red'>
                    16
                </div>
                <div className='grid-item number'>
                    2
                </div>

                <div className='grid-item category'>
                    the most rigorous testing standards
                </div>
                <div className='grid-item'>
                    <img className='icon' src={IconCheckmark} alt='Yes'/>
                </div>
                <div className='grid-item'>
                    <img className='icon' src={IconClose} alt='Yes'/>
                </div>

                <div className='grid-item category'>
                    nutrient density including DHA and choline
                </div>
                <div className='grid-item percentage'>
                    50-100%
                </div>
                <div className='grid-item percentage'>
                    0%
                </div>
            </div>
            <div className='notice'>{nominations(bundle.category)}</div>
        </div>
    );
}